import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import { db, functions } from '../Firebase';

export type ExportFormat = 'csv' | 'json';
export type LeadType = 'leads' | 'partialLeads';

export interface ExportLeadsParams {
  accountId: string;
  startDate: string;
  endDate: string;
  type: LeadType;
  dynamicPageIds?: string[];
  quizIds?: string[];
  format?: ExportFormat;
}

export interface ExportLeadsResponse {
  ok: boolean;
  jobId: string;
  fileName: string;
}

export async function exportLeads(
  params: ExportLeadsParams,
): Promise<ExportLeadsResponse> {
  const fn = httpsCallable<ExportLeadsParams, ExportLeadsResponse>(
    functions,
    'leads/exportLeads',
  );

  const response = await fn(params);
  return response.data;
}

export interface DeleteLeadParams {
  accountId: string;
  leadId: string;
  type: LeadType;
}

export async function deleteLead(params: DeleteLeadParams): Promise<void> {
  const { accountId, leadId, type } = params;
  const leadRef = doc(db, 'accounts', accountId, type, leadId);

  await updateDoc(leadRef, {
    status: 'deleted',
    deletedAt: serverTimestamp(),
  });
}
